<div class="assign modal-content">
  <div class="modal-header">
    <h3 class="modal-title font-weight-bold">Dealer Assignment</h3>
    <button (click)="close();" aria-label="Close" class="btn-close" type="button"></button>
  </div>
  <h3 class="modal-header modal-sub-title font-weight-bold">Assigned</h3>

  <ngx-simplebar [options]="options">
    <table class="table" style="overflow-y: scroll;">
      <thead class="body-head">
      <tr>
        <th>
        </th>
        <th>Name</th>
        <th>BP #</th>
        <th>City</th>
        <th>State</th>
        <th>HQ</th>
        <th>Active Tickets</th>

      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let dealer of this.assignedDealers;" class="body">
        <td>
          <input (change)="onAssignChangeSelect($event)" [checked]="dealer.selected"
                 [value]="dealer.bpNo"
                 class="unAssign-check-box"
                 type="checkbox"
          >
        </td>
        <td>{{ dealer.name }}</td>
        <td>{{ dealer.bpNo }}</td>
        <td>{{ dealer.city }}</td>
        <td>{{ dealer.state }}</td>
        <td>{{ dealer.hq }}</td>
        <td>{{ dealer.activeTickets }}</td>

      </tr>
      </tbody>
    </table>
  </ngx-simplebar>

  <div>
    <div class="modal-footer">
      <button (click)="unAssignDealers()"
              class="save btn btn-outline-dark"
              type="submit"
      >UnAssign
      </button>
    </div>
  </div>

  <h3 class="modal-header modal-sub-title font-weight-bold">Dealers</h3>

  <div class="row mb-0">
    <div class="col-lg-6 col-sm-6">
      <div class="row search-box">
        <div class="col-lg-6 position-relative">
          <ng-select (change)="changeDealer($event)"
                     [items]="dealerSelectGroup"
                     [multiple]="false"
                     bindLabel="name"
                     bindValue="code"
                     class="form-control"
                     placeholder="All Dealers">

          </ng-select>
        </div>
        <div class="col-lg-6 mb-2">
          <div class="position-relative">
            <input [formControl]="searchText"
                   class="form-control border-light rounded"
                   placeholder="Search For"
                   type="text">
            <i class="uil uil-search search-icon"></i>
          </div>
        </div>
      </div>
    </div>

    <div class="table-wrapper">

      <app-dp-list (pageEvent)="onPageEvent($event)"
                   [pagedResponse]="pagedResponse"
                   [selectedItem]="selectedData">
        <table class="table">
          <thead class="body-head font-weight-bold">
          <th>
          </th>
          <th>Name</th>
          <th>BP #</th>
          <th>City</th>
          <th>State</th>
          <th>HQ</th>
          <th>Active Tickets</th>
          <th>Current Agent</th>
          </thead>
          <tbody>
          <tr *ngFor="let dealer of dealerData; let i = index" class="body">
            <td>
              <input (change)="onUnAssignChangeSelect($event)" [checked]="dealer.isSelected"
                     [value]="dealer.bpNo"
                     class="assign-check-box"
                     type="checkbox">
            </td>
            <td>{{ dealer.name }}</td>
            <td>{{ dealer.bpNo }}</td>
            <td>{{ dealer.address?.city }}</td>
            <td>{{ dealer.address?.state }}</td>
            <td>{{ dealer.hq }}</td>
            <td>{{ dealer.activeTickets }}</td>
            <td>{{ dealer.currentAgent }}</td>
          </tr>
          </tbody>
        </table>
      </app-dp-list>
    </div>

    <div>
      <div class="modal-footer">
        <button (click)="assignDealers()"
                class="save btn btn-dark"
                type="submit"
        >Assign
        </button>
      </div>
    </div>

  </div>
</div>
